import {
  GET_CLINIC,
  GET_CLINIC_FAIL,
  GET_CLINIC_SUCCESS,
  GET_CLINIC_DETAILS,
  GET_CLINIC_DETAILS_FAIL,
  GET_CLINIC_DETAILS_SUCCESS,
  ADD_NEW_CLINIC,
  ADD_CLINIC_SUCCESS,
  ADD_CLINIC_FAIL,
  UPDATE_CLINIC,
  UPDATE_CLINIC_SUCCESS,
  UPDATE_CLINIC_FAIL,
  DELETE_CLINIC,
  DELETE_CLINIC_SUCCESS,
  DELETE_CLINIC_FAIL,  
  RESET_CLINIC_STATE,
} from "./actionTypes";

export const getClinic = ({length, sort, page,name, sort_by}) => ({
  type: GET_CLINIC,
  payload: {length, sort, page,name, sort_by},
});

export const getClinicSuccess = clinic => ({
  type: GET_CLINIC_SUCCESS,
  payload: clinic,
});

export const getClinicFail = error => ({
  type: GET_CLINIC_FAIL,
  payload: error,
});

export const getClinicDetails = ({id}) => ({
  type: GET_CLINIC_DETAILS,
  payload: {id},
});

export const getClinicDetailsSuccess = clinic => ({
  type: GET_CLINIC_DETAILS_SUCCESS,
  payload: clinic,
});

export const getClinicDetailsFail = error => ({
  type: GET_CLINIC_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewClinic = clinic => ({
  type: ADD_NEW_CLINIC,
  payload: clinic,
});

export const addClinicSuccess = clinic => ({
  type: ADD_CLINIC_SUCCESS,
  payload: clinic,
});

export const addClinicFail = error => ({
  type: ADD_CLINIC_FAIL,
  payload: error,
});

//update 
export const updateClinic =({id, clinic}) => ({
  type: UPDATE_CLINIC,
  payload:{id, clinic},
});

export const updateClinicSuccess = clinic => ({
  type: UPDATE_CLINIC_SUCCESS,
  payload: clinic,
});

export const updateClinicFail = error => ({
  type: UPDATE_CLINIC_FAIL,
  payload: error,
});

//delete 
export const deleteClinic =({id}) => ({
  type: DELETE_CLINIC,
  payload:{id},
});

export const deleteClinicSuccess = clinic => ({
  type: DELETE_CLINIC_SUCCESS,
  payload: clinic,
});

export const deleteClinicFail = error => ({
  type: DELETE_CLINIC_FAIL,
  payload: error,
});

//reset
export const resetClinicState = () => {
  return {
      type: RESET_CLINIC_STATE,
  }
}


